export function NotEligible() {
  return <span className="">▲</span>
}
